/* eslint-disable */
/**
 * This class is used to manage product data request callbacks for a given market. An example is that a page may ask
 * for product data from firebase and while it is being loaded into local storage another request is made to get the
 * product data for a particular product. Sense the product data has not loaded into local storage yet the request for
 * product data will generate another firebase product data download. The FirebaseProductCallbackUtil is used to make
 * sure only one firebase download is used and that all callbacks dependent on the download will be called after the
 * product data is stored.
 * @type {{market: string, loadedInLocalStorage: boolean, callbackQueue: Array, clear: FirebaseProductCallbackUtil.clear}}
 */
let FirebaseProductCallbackUtil = function(){
    let callbackTable = new $.Hashtable();
    let inProgressTable = new $.Hashtable();

    // ---------------------------------------------
    //
    //        Public Methods
    //
    // ---------------------------------------------
    let publicMethods = {
        addCallbackForMarket: function(market, callback){
            if (callback) {
                let callbacks = callbackTable.get(market);

                if (callbacks == null) {
                    callbacks = [];
                }

                callbacks.push(callback);
                callbackTable.add(market, callbacks);
            }
        },
        isProductDataDownLoadInProcess: function(market){
            return inProgressTable.get(market) === true;
        },
        setProductDataDownloadInProcess: function(market, inProgress){
            inProgressTable.add(market, inProgress);

            if (inProgress == false){
                processCallbacksForMarket(market);
            }
        }
    };

    // ---------------------------------------------
    //
    //        Private Methods
    //
    // ---------------------------------------------
    function processCallbacksForMarket(market){
        let callbacks = callbackTable.get(market);

        if (callbacks && callbacks.length > 0){
            let callback;

            while (callbacks.length > 0){
                // Get and remove the callback.
                callback = callbacks.pop();

                // Execute the callback.
                callback();
            }

            // Remove the callbacks for the market.
            callbackTable.remove(market);
        }
    }

    return publicMethods;
}();

export default FirebaseProductCallbackUtil;
